import { useQuery } from '@tanstack/react-query';
import { getReadyz } from '@/lib/api';
import { Code2, Globe } from 'lucide-react';

export function VersionFooter() {
  const { data } = useQuery({
    queryKey: ['readyz'],
    queryFn: getReadyz,
    staleTime: 60_000,
  });
  return (
    <footer className="mt-auto border-t border-[var(--color-border)] py-6 text-sm text-[var(--color-muted-foreground)]">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 px-6 sm:flex-row">
        <div className="flex items-center gap-2">
          <Globe className="h-4 w-4" />
          <a href="https://heuristichero.com" className="hover:text-[var(--color-primary)]">
            heuristichero.com
          </a>
          <span className="px-1">·</span>
          <span>Powered by Microsoft Agent Framework · Microsoft Foundry · Microsoft Azure</span>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="https://github.com/CrankingAI/heuristic-hero"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 hover:text-[var(--color-primary)]"
          >
            <Code2 className="h-4 w-4" /> source
          </a>
          {data && (
            <span className="font-mono">
              v{data.version} ({data.shortCommit})
            </span>
          )}
        </div>
      </div>
    </footer>
  );
}
